import { XMarkIcon } from '@heroicons/react/24/outline';
import React from 'react';

export const CloseIcon = () => <XMarkIcon className='w-5' />;
